import React, {useState} from 'react';
import { observer } from 'mobx-react'
import '../index.css';
import {changepopupaddSegment, changesegmentationpage} from "../../../stores/GlobalState";
import lang from "../../../lang"
const PopupInfo = observer(() =>{
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const rechangepopup = (a) =>{
        changesegmentationpage(a)
        changepopupaddSegment()
    }
    return (
        <div className="popupInfofon addsegment_new">
            <div className="popupInfo dataset">
                <div className='top-element'>
                    <div className='namepopup'>
                    {langv?.segmentation?.choose_how_to_add_attribute}
                    </div>
                    <div></div>
                    <div className='buttonspopup'>
                        <div className='buttonexit' onClick={changepopupaddSegment}>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7891 5.27441L6.24236 18.181" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M6.06055 5.45312L18.9671 17.9998" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='adddataset-element centerflex'>
                    <div className='buttonDataset' onClick={()=>rechangepopup(3)}>
                    {langv?.segmentation?.select_attribute}
                    </div>
                    <div className='buttonDataset' onClick={()=>rechangepopup(5)}>
                    {langv?.segmentation?.create_segmentation}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PopupInfo;
